<template>
  <JobApplyLayout :step="0">
    <div class="wrapper">
      <JobApplyDetail
        :user="user"
        :job="job"
        :token="token"
        :show-job-commission="false"
        :show-job-status-sticker="false"
        :show-candidate-status="false"
        :show-post-date="false"
        :show-job-key-points="false"
      />
    </div>
    <div v-if="job.jobShareable" class="btn-group">
      <button class="btn-close" @click="goToHome">
        I’m not interested in this job
      </button>
      <div class="b-g">
        <JobApplyButton
          v-if="formType === 'both' || formType === 'full'"
          :job="job"
          :token="token"
          :form-label="requiredCV"
          :form-type="'full'"
        />
        <JobApplyButton
          v-if="formType === 'both' || formType === 'simple'"
          :job="job"
          :token="token"
          :form-label="optionalCV"
          :form-type="'simple'"
        />
      </div>
    </div>
  </JobApplyLayout>
</template>

<script>
import JobApplyLayout from 'components/layouts/job_apply/JobApplyLayout.vue'
import JobApplyDetail from 'components/ui/JobApplyDetail.vue'
import JobApplyButton from 'components/ui/button/JobApplyButton.vue'

const ViewProps = window._application.props

export default {
  components: {
    JobApplyLayout,
    JobApplyDetail,
    JobApplyButton,
  },

  data() {
    return {
      job: ViewProps.form.userJobShare.job,
      user: ViewProps.form.userJobShare.user,
      token: ViewProps.form.userJobShare.token,
      formType: ViewProps.form.userJobShare.formType,
      requiredCV: '(Require CV)*',
      optionalCV: '(Optional CV)',
    }
  },

  methods: {
    goToHome() {
      window.location.href = '/'
    },
  },
}
</script>

<style scoped lang="scss">
@import 'stylesheets/global';

.details {
  padding: 20px 50px;
}

.btn-group {
  display: flex;
  justify-content: center;
  padding: 2rem 0;

  button {
    border: 1px solid #3742fa;
    border-radius: 100rem;
    color: white;
    cursor: pointer;
    font-size: 1rem;
    font-style: normal;
    font-weight: 700;
    padding: 1rem 1.5rem;
    text-align: center;

    &.btn-close {
      background-color: white;
      color: $blue-primary;
      margin-right: 10px;
    }
  }
}

@include sp {
  .details {
    padding: 10px;
  }

  .btn-group {
    align-items: flex-end;
    padding: 10px 0;

    button {
      font-size: 13px;
      padding: 10px 15px;
    }
  }
}
</style>
